import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Input, Button } from "mdbreact";
import domain from ".././../../../domain";
import { Row, Col, Card, CardBody } from "mdbreact";
class EditParticipant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "1 ",
      name: "syam ",
      designation: " ",
      organization: " ",
      city: " ",
      address: " ",
      tstate: " ",
      email: " ",
      mobile: " ",
      department: " ",
      gender: " ",
      course_id: " ",
      data: [],
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentWillMount() {
    this.getParticipantDetails();
    this.getCourseDetails();
  }
  getCourseDetails() {
    let participantId = this.props.match.params.id;
    axios
      .get(`${domain.DBServer}/fetch-course-trainee/${participantId}`)
      .then((response) => {
        this.setState({
          data: response.data,
          course_id: response.data[0].course_id,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getParticipantDetails() {
    let participantId = this.props.match.params.id;
    console.log(participantId);
    axios
      .get(`${domain.DBServer}/fetch-participant/${participantId}`)
      .then((participant) => {
        console.log(participant.data);
        this.setState({
          id: participant.data[0].trainee_id,
          name: participant.data[0].name,
          designation: participant.data[0].designation,
          organization: participant.data[0].organization,
          city: participant.data[0].city,
          address: participant.data[0].address,
          tstate: participant.data[0].t_state,
          email: participant.data[0].email,
          mobile: participant.data[0].mobile,
          department: participant.data[0].department,
          gender: participant.data[0].gender,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  editParticipant(newParticipant) {
    // let r=window.confirm('Please check once again the updated details');
    // if(!r) {return false; }
    let participantId = this.props.match.params.id;
    axios
      .request({
        method: "PUT",
        url: `${domain.DBServer}/edit-participantdetails/${participantId}`,
        data: newParticipant,
      })
      .then((response) => {
        console.log(response.data);
        if (response.data === 1) {
          alert("Details are updated Successfully");
          this.props.history.push(`/view-trainees/${this.state.course_id}`);
        } else {
          alert("Details are not updated");
        }
      })
      .catch((err) => console.log(err));
  }

  onSubmit(e) {
    const newParticipant = {
      name: this.state.name,
      designation: this.state.designation,
      organization: this.state.organization,
      city: this.state.city,
      address: this.state.address,
      tstate: this.state.tstate,
      email: this.state.email,
      mobile: this.state.mobile,
      department: this.state.department,
      gender: this.state.gender,
    };
    this.editParticipant(newParticipant);
    e.preventDefault();
  }

  handleInputChange(e) {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    console.log(value);
    this.setState({
      [name]: value,
    });
  }

  render() {
    return (
      <div>
        <br />
        <Row className="justify-content-md-center">
          <Col md="6">
            <Card>
              <CardBody>
                <h1 style={{ textAlign: "center", color: "blue" }}>
                  Edit Participant
                </h1>
                <Link
                  className="btn grey"
                  to={`/view-trainees/${this.state.course_id}`}
                >
                  Back
                </Link>

                <form onSubmit={this.onSubmit.bind(this)}>
                  <Input
                    label="Trainee Name"
                    id="name"
                    name="name"
                    value={this.state.name}
                    group
                    type="text"
                    validate
                    error="wrong"
                    success="right"
                    onChange={this.handleInputChange}
                    required="required"
                  />
                  <Input
                    label="Designation"
                    id="designation"
                    value={this.state.designation}
                    name="designation"
                    group
                    type="text"
                    validate
                    error="wrong"
                    success="right"
                    onChange={this.handleInputChange}
                    required="required"
                  />
                  <Input
                    label="Organization"
                    id="organization"
                    name="organization"
                    value={this.state.organization}
                    group
                    type="text"
                    validate
                    error="wrong"
                    success="right"
                    onChange={this.handleInputChange}
                    required="required"
                  />
                  <Input
                    type="textarea"
                    label="Address"
                    id="address"
                    name="address"
                    value={this.state.address}
                    group
                    validate
                    error="wrong"
                    success="right"
                    onChange={this.handleInputChange}
                    required="required"
                  />
                  <Input
                    label="City"
                    id="city"
                    name="city"
                    group
                    type="text"
                    value={this.state.city}
                    validate
                    error="wrong"
                    success="right"
                    onChange={this.handleInputChange}
                    required="required"
                  />
                  <Input
                    label="State"
                    id="tstate"
                    name="tstate"
                    group
                    type="text"
                    value={this.state.tstate}
                    validate
                    error="wrong"
                    success="right"
                    onChange={this.handleInputChange}
                    required="required"
                  />
                  <Input
                    label="Email"
                    id="email"
                    name="email"
                    group
                    type="email"
                    value={this.state.email}
                    validate
                    error="wrong"
                    success="right"
                    onChange={this.handleInputChange}
                    required="required"
                  />
                  <Input
                    label="Mobile"
                    id="tel"
                    name="mobile"
                    group
                    type="tel"
                    value={this.state.mobile}
                    validate
                    pattern="[0-9]{10}"
                    error="wrong"
                    success="right"
                    onChange={this.handleInputChange}
                    required="required"
                  />
                  <Input
                    label="Department"
                    id="department"
                    name="department"
                    group
                    type="text"
                    value={this.state.department}
                    validate
                    error="wrong"
                    success="right"
                    onChange={this.handleInputChange}
                    required="required"
                  />
                  <div class="form-check-inline">
                    {" "}
                    Gender
                    <div className="form-check">
                      <label className="form-check-label">
                        <input
                          type="radio"
                          style={{ opacity: "20" }}
                          checked={this.state.gender === "Male"}
                          className="form-check-input"
                          name="gender"
                          value="Male"
                          onChange={this.handleInputChange}
                          required="required"
                        />
                        Male
                      </label>
                    </div>
                    <div className="form-check">
                      <label className="form-check-label">
                        <input
                          type="radio"
                          style={{ opacity: "20" }}
                          checked={this.state.gender === "Female"}
                          className="form-check-input"
                          name="gender"
                          value="Female"
                          onChange={this.handleInputChange}
                          required="required"
                        />
                        Female
                      </label>
                    </div>
                  </div>

                  <Button type="submit">Submit</Button>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default EditParticipant;
